var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLynxScreenRecorderLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lynx-screen-recorder-logo_svg__b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 337.82,
    height: 337.82,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 337.82 337.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-screen-recorder-logo_svg__d",
    x1: -8.11,
    y1: 302.37,
    x2: 303.45,
    y2: 67.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#374df2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f410ce"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "lynx-screen-recorder-logo_svg__c"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 168.66,
    cy: 169.16,
    r: 168.66,
    style: {
      fill: "url(#lynx-screen-recorder-logo_svg__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.32,169.16c0,93.15-75.51,168.66-168.66,168.66S0,262.31,0,169.16,75.51.5,168.66.5s168.66,75.51,168.66,168.66ZM168.66,35.16c-74.01,0-134,59.99-134,134s59.99,134,134,134,134-59.99,134-134S242.66,35.16,168.66,35.16Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.2,186.69h-29.43v58.44h-26.4V93.19h53.43c17.53,0,31.06,3.93,40.59,11.8,9.53,7.87,14.3,19.25,14.3,34.15,0,10.17-2.45,18.68-7.36,25.53-4.9,6.86-11.74,12.13-20.5,15.82l34.12,63.27v1.35h-28.28l-30.47-58.44Zm-29.43-21.29h27.13c8.9,0,15.86-2.24,20.87-6.73,5.01-4.49,7.51-10.63,7.51-18.42s-2.31-14.43-6.94-18.89c-4.63-4.45-11.53-6.75-20.71-6.89h-27.86v50.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.24,23.64C38.46,49.82,7.02,95.46,1.02,150.07c-10.16,92.59,56.66,175.89,149.25,186.06,37.78,4.15,74.02-4.53,104.37-22.54-16.42-3.37-93.07-20.91-143.27-94.55C51.64,131.41,78.44,36.3,82.24,23.64Z",
    style: {
      fill: "#38004f",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.2,186.69h-29.43v58.44h-26.4V93.19h53.43c17.53,0,31.06,3.93,40.59,11.8,9.53,7.87,14.3,19.25,14.3,34.15,0,10.17-2.45,18.68-7.36,25.53-4.9,6.86-11.74,12.13-20.5,15.82l34.12,63.27v1.35h-28.28l-30.47-58.44Zm-29.43-21.29h27.13c8.9,0,15.86-2.24,20.87-6.73,5.01-4.49,7.51-10.63,7.51-18.42s-2.31-14.43-6.94-18.89c-4.63-4.45-11.53-6.75-20.71-6.89h-27.86v50.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.66.3c74.77-4.73,144.52,47.16,163.74,119.19,2.91,10.77,4.62,21.9,5.2,33.03.07,2.78.19,5.56.22,8.33l-.3,8.31C335.64,75.15,262.64,2.18,168.66.3h0Z",
    style: {
      fill: "#ffc9f9"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLynxScreenRecorderLogo);
export default __webpack_public_path__ + "static/media/lynx-screen-recorder-logo.00d95127fd1997f084855804735db015.svg";
export { ForwardRef as ReactComponent };